import { useRef } from 'react';
import { Button, Space, Typography } from 'antd';
import { CameraOutlined, FileAddOutlined, DeleteOutlined, FileImageOutlined, FilePdfOutlined } from '@ant-design/icons';

const { Text } = Typography;
const ACCEPTED = '.pdf,.jpg,.jpeg,.png,.tiff,.tif,.bmp,.webp';

export default function FileUploader({ files, onFilesChange }) {
  const browseRef  = useRef(null);
  const cameraRef  = useRef(null);

  function mergeFiles(newFiles, existing) {
    const existingKeys = new Set(existing.map(f => `${f.name}-${f.size}`));
    const merged = [...existing];
    for (const f of newFiles) {
      if (!existingKeys.has(`${f.name}-${f.size}`)) merged.push(f);
    }
    return merged;
  }

  function handleBrowse(e) {
  const selected = Array.from(e.target.files || []);
  if (selected.length) onFilesChange([selected[0]]);  // ← takes only first file
  e.target.value = '';
  }

  function handleCamera(e) {
  const selected = Array.from(e.target.files || []);
  if (selected.length) onFilesChange(mergeFiles(selected, files));
  e.target.value = '';
  }

  // function handleInput(e) {
  //   const selected = Array.from(e.target.files || []);
  //   if (selected.length) onFilesChange(mergeFiles(selected, files));
  //   e.target.value = '';
  // }

  function removeFile(index) {
    onFilesChange(files.filter((_, i) => i !== index));
  }

  const totalKB = (files.reduce((s, f) => s + f.size, 0) / 1024).toFixed(0);

  return (
    <div>
      {/* ── two action buttons ── */}
      <Space direction="vertical" style={{ width: '100%' }} size={10}>

        {/* Upload from gallery/files */}
        <Button
          icon={<FileAddOutlined />}
          size="large"
          style={{ width: '100%', height: 52, fontSize: 15 }}
          onClick={() => browseRef.current?.click()}
        >
          Upload File
        </Button>
        <input
          ref={browseRef}
          type="file"
          accept={ACCEPTED}
          onChange={handleBrowse}
          style={{ display: 'none' }}
        />

        {/* Camera capture — uses capture="environment" for rear camera on mobile */}
        <Button
          icon={<CameraOutlined />}
          size="large"
          type="dashed"
          style={{ width: '100%', height: 52, fontSize: 15 }}
          onClick={() => cameraRef.current?.click()}
        >
          Capture with Camera
        </Button>
        {/*
          capture="environment" = rear camera (recommended for document scanning)
          Remove capture attribute to let user choose front/rear camera
          On desktop browsers this opens the file picker as a fallback
        */}
        <input
          ref={cameraRef}
          type="file"
          accept="image/*"
          capture="environment"
          multiple
          onChange={handleCamera}
          style={{ display: 'none' }}
        />

      </Space>

      {/* ── file list ── */}
      {files.length > 0 && (
        <div style={{ marginTop: 14 }}>
          <Text type="secondary" style={{ fontSize: 12, display: 'block', marginBottom: 8 }}>
            {files.length} file{files.length !== 1 ? 's' : ''} · {totalKB} KB total
          </Text>
          <Space direction="vertical" style={{ width: '100%' }} size={6}>
            {files.map((f, i) => {
              const isPdf = f.type === 'application/pdf';
              return (
                <div key={i} className="file-list-item">
                  {isPdf
                    ? <FilePdfOutlined style={{ color: '#ff4d4f', fontSize: 16 }} />
                    : <FileImageOutlined style={{ color: '#1677ff', fontSize: 16 }} />
                  }
                  <span className="file-name">{f.name}</span>
                  <Text type="secondary" style={{ fontSize: 11, whiteSpace: 'nowrap' }}>
                    {(f.size / 1024).toFixed(1)} KB
                  </Text>
                  <Button
                    type="text"
                    danger
                    size="small"
                    icon={<DeleteOutlined />}
                    onClick={() => removeFile(i)}
                  />
                </div>
              );
            })}
          </Space>
        </div>
      )}
    </div>
  );
}